import React from 'react'

import { Skeleton } from '@material-ui/lab'

import { SwitchTabsSkeletonProps } from './SwitchTabsSkeleton.types';

const SwitchTabsSkeleton: React.FC<SwitchTabsSkeletonProps> = ({className}) => {
  return (
    <div className='flex flex-row width-100'>
      <Skeleton variant="rect" height={30} className="width-50 py3 br1" />
      <Skeleton variant="rect" height={30} className="width-50 py3 ml1 br1" />
    </div>
  )
}

export default SwitchTabsSkeleton
export { SwitchTabsSkeletonProps };